import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack } from '@mui/material';
import { useLocation } from 'react-router-dom';
import ErrorImage from '../images/error.png';
import { StyledLink } from '../components/StyledComponent';
import SupportLink from '../components/SupportLink';
export default function ErrorPage() {
    const search = useLocation().search;
    const urlSearchParams = new URLSearchParams(search);
    const status = urlSearchParams.get('status');
    const message = urlSearchParams.get('message');
    const detail = urlSearchParams.get('detail');
    const origin = urlSearchParams.get('origin');
    return (_jsx("div", { children: _jsxs(Stack, { alignItems: "center", children: [_jsx(Box, { component: "img", sx: {
                        height: 350,
                        width: 350,
                    }, alt: "Error", src: ErrorImage }), _jsx("div", { children: "Something went wrong, try again. Log out and log in again if the issue persists." }), _jsx("div", { children: _jsx(StyledLink, { to: "/DashboardPage", children: "Go back to dashboard" }) }), _jsxs(Box, { display: "flex", alignItems: "center", flexDirection: "column", style: {
                        marginTop: '50px',
                        color: 'darkgray',
                        fontStyle: 'italic',
                    }, children: ["Error:", status && +status != 0 && ` Status ${status} -`, " ", message || 'Unknown', _jsx("br", {})] }), _jsxs("div", { children: ["Thanks for reporting the error ", _jsx(SupportLink, { text: "here" }), ' '] })] }) }));
}
